// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pageNotFound_wrapper__119Tc","info":"pageNotFound_info__11Uno","mobileWrapper":"pageNotFound_mobileWrapper__94jxg"};